import { FormattedMessage, useIntl } from 'react-intl'
import { GridHeaderCell } from '../../../components/Grid'

import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import { useMediaQuery } from '../../../../hooks'
import { AutomationObjectCard } from '../../../components/Grid/AutomationObjectCard'
import RenderIfVisible from 'react-render-if-visible'



export const OutgoingAirPanel = ({ childElements }) => {
    const intl = useIntl();
    const outgoingDuct = childElements?.find((v: any) => v.schema === "AutomationApps.SubPlants.AirDucts.SP_OutgoingAirDuct");
    const outgoingFilter = childElements?.find((v: any) => v.schema === "AutomationApps.SubPlants.Filters.SP_OutgoingFilter");
    const outgoingFlap = childElements?.find((v: any) => v.schema === "AutomationApps.SubPlants.Flaps.SP_OutgoingFlap");

    const efficiency = childElements?.find((v: any) => v.schema === "AutomationApps.Utils.Efficiency");
    const isHighRatio = useMediaQuery("only screen and (-webkit-min-device-pixel-ratio: 1.5)");
    const columnCount = isHighRatio ? [1, 1, 2, 3] : [1, 1, 2, 4];
    return (
        <>
            <>
                {(outgoingFlap || outgoingDuct || outgoingFilter) &&
                    <GridHeaderCell header={<FormattedMessage id="P_AirHandling.OutgoingAir" defaultMessage="Outgoing Air" />}></GridHeaderCell>
                }


                <FlexGrid
                    flexGridColumnCount={columnCount}
                    flexGridColumnGap="scale800"
                    flexGridRowGap="scale800"
                >
                    {childElements?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.Filters.SP_OutgoingFilter") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                    {childElements?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.AirDucts.SP_OutgoingAirDuct") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                    {childElements?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.Flaps.SP_OutgoingFlap") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                </FlexGrid>
            </>
           
        </>
    );
}